<template>
  <div class="pa-wide-modal-box-wrapper">
    <div class="pa-wide-modal-box" ref="wideModalBox">
      <div class="pa-header">
        <div class="pa-title">
          <slot name="title"></slot>
        </div>
        <div class="pa-description">
          <p>
            <slot name="description" />
          </p>
        </div>
        <div class="pa-caption" v-if="hasCaptionSlot">
          <p>
            <slot name="caption" />
          </p>
        </div>
      </div>

      <div class="pa-cancel" v-if="shoudDisplayCancelButton">
        <button
        class="button pa-cancel-button"
        :class="cancelButtonClass"
        :disabled="isDisabledCancelButton"
        @click.prevent="handleClickCancelButton"
        >{{cancelButtonText}}</button>
      </div>

      <template v-if="(itemImageName !== null) && (itemImageComponentName !== null)">
        <div class="pa-item-image-wrapper" :class="imageWrapperClass">
          <component :is="itemImageComponentName" class="pa-svg-item-image" :class="itemImageClass"></component>
        </div>
      </template>

      <div class="pa-message-title" v-if="hasMessageTitleSlot">
        <slot name="messageTitle" />
      </div>

      <div class="pa-message" v-if="hasMessageSlot">
        <slot name="message" />
      </div>

      <template v-if="character !== null">
        <CharacterIcon :character="character" :clickable="false" />
      </template>

      <template v-if="countUpCircleText !== null">
        <PACountUpTextCircle :count="countUpCircleText" :couldStartCounting="isEnterdContent" />
      </template>

      <template v-if="lineMessage !== null">
        <p class="line-message"><font-awesome-icon v-if="lineMessageIcon !== null" :icon="lineMessageIcon" />{{lineMessage}}</p>
      </template>

      <button
      class="button pa-confirm-button"
      :class="submitButtonClass"
      :disabled="isDisabledSubmitButton"
      @click.prevent="handleClickSubmitButton"
      >{{confirmButtonText}}</button>
    </div>
  </div>
</template>

<script>
import CharacterIcon from '@/components/Parts/CharacterIcon/CharacterIcon.vue'

import PACountUpTextCircle from '@/components/Parts/PACountUpTextCircle/PACountUpTextCircle.vue'

import itemShakokiDoguImage     from '@/components/Parts/PAWideModalBox/Images/shakoki-dogu-box.svg?inlineN'
import itemHaniwaImage          from '@/components/Parts/PAWideModalBox/Images/haniwa-box.svg?inlineN'
import itemKinakoKibidangoImage from '@/components/Parts/PAWideModalBox/Images/kinako-kibidango-box.svg?inlineN'
import itemKibidangoImage       from '@/components/Parts/PAWideModalBox/Images/kibidango-box.svg?inlineN'
import itemCastellaImage       from '@/components/Parts/PAWideModalBox/Images/castella-box.svg?inlineN'
import itemNoImageImage         from '@/components/Parts/PAWideModalBox/Images/no-item-image.svg?inlineN'

export default {
  props : {
    character : {
      default : null,
    },

    itemImageName : {
      default : null
    },
    
    confirmButtonText : {
      default : '続ける'
    }, 

    shoudDisplayCancelButton : {
      default : true
    },

    cancelButtonText : {
      default : 'キャンセルする'
    },

    isSubmitLoading : {
      default : false
    },

    isDisabledSubmit : {
      default: false
    },

    lineMessage : {
      default: null
    },

    lineMessageIcon : {
      default: 'exclamation-triangle'
    },

    countUpCircleText : {
      default: null
    },

    isEnterdContent : {
      default: null
    }
  },

  components : {
    CharacterIcon,
    PACountUpTextCircle,

    itemShakokiDoguImage,
    itemHaniwaImage,
    itemKinakoKibidangoImage,
    itemKibidangoImage,
    itemCastellaImage,
    itemNoImageImage
  },

  data(){
    return {
      itemImageClass            : [],
      
      imageWrapperClass         : {
        'pa-item-image-wrapper-margin-widely'  : false
      },

      isDisabledSubmitButton    : false,
      submitButtonClass         : {
        'is-loading'  : false
      },

      isDisabledCancelButton    : false,
      cancelButtonClass         : [],

      itemImageComponentName    : null,

      itemImageComponentNameSet : {
        'shakoki-dogu'      : 'itemShakokiDoguImage',
        'haniwa'            : 'itemHaniwaImage',
        'kinako-kibidango'  : 'itemKinakoKibidangoImage',
        'kibidango'         : 'itemKibidangoImage',
        'castella'          : 'itemCastellaImage',
        'no-image'          : 'itemNoImageImage'
      }
    };
  },

  computed : {
    hasCaptionSlot(){
      return !!this.$slots.caption;
    },

    hasMessageTitleSlot(){
      return !!this.$slots.messageTitle;
    },

    hasMessageSlot(){
      return !!this.$slots.message;
    }
  },

  watch : {
    isDisabledSubmit : {
      handler(value){
        this.isDisabledSubmitButton = value;
      },
      immediate: true
    },

    itemImageName : {
      handler(value){
        if(typeof this.itemImageComponentNameSet[value] !== 'undefined'){
          this.itemImageComponentName = this.itemImageComponentNameSet[value];
          this.itemImageClass         = [value];
        }else{
          this.itemImageComponentName = this.itemImageComponentNameSet['no-image'];
          this.itemImageClass         = ['no-image'];
        }
      },
      immediate: true
    },

    isSubmitLoading(value){
      if(value === true){
        this.isDisabledSubmitButton = true;
        this.isDisabledCancelButton = true;
        this.submitButtonClass['is-loading'] = true;
      }else{
        this.isDisabledSubmitButton = false;
        this.isDisabledCancelButton = false;
        this.submitButtonClass['is-loading'] = false;
      }
    },

    shoudDisplayCancelButton : {
      handler(value){
        if(value === true){
          this.imageWrapperClass['pa-item-image-wrapper-margin-widely'] = false;
        }else{
          this.imageWrapperClass['pa-item-image-wrapper-margin-widely'] = true;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleClickSubmitButton(){
      this.$emit('handleSubmit');
    },

    handleClickCancelButton(){
      this.$emit('handleCancel');
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-wide-modal-box-wrapper{
  width:100vw;
  height:100vh;
}

.pa-wide-modal-box{
  margin:0 auto;
  width:100vw;
  min-height:70vh;
  background-color: #CAB090;
  border-top:5px solid #89620C;
  border-bottom:5px solid #89620C;

  .pa-content-field{
    width:98%;
    margin:0 auto .5rem;
    position: relative;
    height:auto;
    overflow: hidden;
  }

  .pa-header{
    width:97%;
    margin:.8rem auto .4rem;
    padding-bottom:.4rem;
    background-color:#CCAA8B;

    .pa-title{
      color:#7F4F16;
      font-size:1.5rem;
      line-height: 1.5rem;
      text-align: center;
      width:95%;
      margin:0 auto;
      padding:.5rem 0 .3rem;
      border-bottom: 3px solid #C49065;

      @include until(375px) {
      font-size:1.2rem;
      line-height: 1.2rem;
      }
    }

    .pa-description{
      width:95%;
      margin:0 auto;
      padding:.2rem 0 .5rem;
      color: #7C5E49;
      
      @include until(375px) {
        padding-bottom:.2rem;
      }

      p{
        text-align: center;
        @include until(375px) {
          font-size:.9rem;
        }
      }
    }
    
    .pa-caption{
      background-color:#CAA583;
      border-radius:4px;
      padding:.2rem .1rem;
      width:95%;
      margin:0 auto;
      font-size:.8rem;
      text-align:center;
      color: #7C5E49;

      @include until(375px) {
        font-size:.7rem;
      }
    }
  }

  .pa-item-image-wrapper{
    &-margin-widely{
      margin-top:1.3rem;
    }
  }

  svg.pa-svg-item-image{
    display: block;
    width:55%;
    margin:.5rem auto 1rem;

    &.shakoki-dogu{
      .a{fill:#ddceb3;stroke:#89620c;stroke-width:2px;}
      .a,.d,.e{stroke-miterlimit:10;}
      .b{fill:#bcab95;}
      .c{fill:#77592c;}
      .d,.e{fill:#9e8167;stroke:#604635;}
      .d{stroke-width:2.19px;}
      .e{stroke-width:1.75px;}
      .f{fill:#604635;}
    }

    &.haniwa{
      .a{fill:#ddceb3;stroke:#89620c;stroke-miterlimit:10;stroke-width:2px;}
      .b{fill:#bcab95;}
      .c{fill:#77592c;}
      .d{fill:#3a3a3a;}
    }

    &.kinako-kibidango{
      .a{fill:#ddceb3;stroke:#89620c;stroke-width:2px;}
      .a,.d,.e{stroke-miterlimit:10;}
      .b{fill:#bcab95;}
      .c{fill:#bcafa2;}
      .d{fill:#eabc49;stroke:#d1a139;stroke-width:1.45px;}
      .e{fill:#baa170;stroke:#b59578;stroke-width:0.36px;}
      .f{fill:#77592c;}
    }

    &.kibidango{
      .a{fill:#ddceb3;stroke:#89620c;stroke-width:2px;}
      .a,.c,.d{stroke-miterlimit:10;}
      .b{fill:#bcafa2;}
      .c{fill:#ede5cc;stroke:#e2d8bf;stroke-width:1.45px;}
      .d{fill:#baa170;stroke:#b59578;stroke-width:0.36px;}
      .e{fill:#bcab95;}
      .f{fill:#77592c;}
    }

    &.castella{
      .a{fill:#ddceb3;stroke:#89620c;stroke-width:2px;}
      .a,.d{stroke-miterlimit:10;}
      .b{fill:#bcab95;}
      .c{fill:#bcafa2;}
      .d{fill:#baa170;stroke:#b59578;stroke-width:0.25px;}
      .e{fill:#c6884f;}
      .f{fill:#ddc6b1;}
      .g{fill:#77592c;}
    }

    &.no-image{
      .a{fill:#ccc;}
    }
  }

  .pa-message-title{
    font-size:1.1rem;
    text-align: center;
    margin:.1rem auto 0;
    
    .bold{
      font-weight: bold;
    }
  }

  .pa-message{
    padding:0 .3rem;
    width:95%;
    margin:.3rem auto .7rem;
    font-size:.9rem;
  }

  .line-message{
    text-align: center;
    font-size:.9rem;
    line-height: 1.4rem;
    padding:.2rem;
    font-weight: bold;
    background-color: #bda51d;
    color:#7c470a;
    width:80%;
    margin:-.3rem auto .5rem;
    border-radius:8px;
    
    svg{
      margin-right:.4rem;
    }
  }

  .pa-item-image{
    display: block;
    width:55vw;
    margin:.5rem auto 1rem;
  }

  .pa-character-icon{
    background-color:#C4A27A;
    width:180px;
    height:180px;
    line-height: 170px;
    font-size: 5rem;
    margin:.2rem auto 1rem;
  }

  .pa-confirm-button{
    display: block;
    width:70%;
    margin:0 auto;
    border-radius: 20px;
    background-color: #C49065;
    border:2px solid #A4734B;
    color: #5E3717;
    text-align: center;
    font-size:1.1rem;
    line-height: 1.1rem;
    padding:.5rem .3rem;
    margin-bottom:1rem;
    // height:inherit;

    @include until(375px) {
      font-size:1rem;
      line-height: 1rem;
    }

    &.is-loading{
      background-color: #B9916F;
      border-color: #B58A68;
    }

    &.is-loading::after{
      border: 1.3px solid #6C482B;
      border-right-color: transparent;
      border-top-color: transparent;
    }

    &:disabled{
      background-color: #C49065;
      border:2px solid #A4734B;
    }

    &:active, &:hover, &:focus, .is-focused{
      border-color: #A4734B;
      color: #5E3717;
    }
  }

  .pa-cancel{
    width:95%;
    margin:0 auto;
    padding:.1rem .1rem 0 0;
    text-align: right;
    line-height: 1;
  }
  
  .pa-cancel-button{
    margin:0;
    padding:0;
    border:0;
    background-color:inherit;
    height: auto;
    line-height: 1;
    font-size: .7rem;
    text-decoration: underline;
    color: #7C5E49;
    font-weight: bold;

    &:disabled{
      background-color: inherit;
    }
  }

  @include from($desktop){
    width:650px;
    height:auto;
    border-radius: 8px;
    border-top:5px solid #89620C;
    border-left:5px solid #89620C;
    border-right:5px solid #89620C;
    border-bottom:5px solid #89620C;

    .pa-content-field{
      border-radius: 8px;
    }

    .pa-confirm-button{
      margin-bottom:1.5rem;
    }
  }
}
</style>